<template>
  <div class="container facebook-login-wrapper">
    <el-button
      :icon="isWorking ? 'icon-loading' : 'icon-facebook'"
      class="fb-button"
      round
      @click="buttonClicked"
    >
      <span
        class="text"
        v-html="getButtonText"
      />
    </el-button>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import FacebookLogin from 'facebook-login-vuejs';
import { loadFbSdk } from 'facebook-login-vuejs/src/helpers';
import icon from 'facebook-login-vuejs/src/icon.png';
import mutations from '@/store/temp/temp.mutationlist';

export default {
  props: FacebookLogin.props,
  data() {
    return {
      isWorking: false,
      isConnected: false,
      icon,
    };
  },
  computed: {
    getButtonText() {
      const superMethod = FacebookLogin.computed.getButtonText.bind(this);
      return superMethod().replace('/', '<b>').replace('\\', '</b>');
    },
    ...mapState({
      facebookInit: state => state.temp.social.facebookInit,
    }),
  },
  created() {
    if (!this.facebookInit) {
      this.isWorking = true;
      loadFbSdk(this.appId, this.version)
        .then(() => {
          this.isWorking = false;
        });
      this.$store.commit(mutations.FACEBOOK_INITIALIZED, true);
    }
  },
  methods: FacebookLogin.methods,
};
</script>

<style scoped>
  .facebook-login-wrapper button {
    position: relative;
    padding: 0 15px 0px 46px;
    border: none;
    line-height: 34px;
    font-size: 16px;
    color: #FFF;
    min-width: 225px;
    background-image: linear-gradient(#4C69BA, #3B55A0);
  }

  .facebook-login-wrapper .spinner {
    box-sizing: border-box;
    width: 30px;
    height: 90%;
    border-radius: 50%;
    border: 5px solid #f3f3f3;
    border-top: 5px solid #3498db;
    animation: spin 2s linear infinite;
    position: absolute;
    left: 5px;
  }

  .facebook-login-wrapper img {
    position: absolute;
    top: 3px;
    left: 10px;
    width: 30px;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/conectivity/FacebookLogin.vue